import { combineReducers } from "redux";
import adminAccountsSummaryCountReducer from "./admin_analytics_reducer.js";
import groupWiseAccountsCountReducer from "./group_wise_accounts_reducer.js";

const adminAnalyticsReducer = combineReducers({
  accountsSummaryCount: adminAccountsSummaryCountReducer ,
  groupWiseAccountsCount : groupWiseAccountsCountReducer
});

export default adminAnalyticsReducer;
